import { Paper } from '@mui/material';
import { node, object, string } from 'prop-types';
import React from 'react';

const Actions = ({ children, className = null, sx = undefined }) => (
  <Paper
    elevation={1}
    square
    className={className}
    sx={[
      theme => ({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderTop: `1px solid ${theme.palette.divider}`,
        padding: theme.spacing(1),
        ...(theme.palette.mode === 'light' && {
          backgroundColor: theme.palette.secondary.ultraUltraLight,
        }),
      }),
      ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
    ]}
  >
    {children}
  </Paper>
);

Actions.propTypes = {
  children: node.isRequired,
  className: string,
  sx: object,
};

export default Actions;
